import type { Label } from '@atlassian/jira-servicedesk-knowledge-services/src/types';

export const ADD_LABELS_TO_ARTICLE_SUCCESS =
	'state.actions.add-labels-to-article-success.ADD_LABELS_TO_ARTICLE_SUCCESS' as const;

export type AddLablesToArticleSuccess = {
	articleId: string;
	labels: Label[];
};

export type AddLablesToArticleSuccessAction = {
	type: typeof ADD_LABELS_TO_ARTICLE_SUCCESS;
	payload: AddLablesToArticleSuccess;
};

export const addLabelsToArticleSuccess = (
	payload: AddLablesToArticleSuccess,
): AddLablesToArticleSuccessAction => ({
	payload,
	type: ADD_LABELS_TO_ARTICLE_SUCCESS,
});
